  <!-- DeviceMng 采集点维护 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="deviceMng">
      <div class="deviceMng_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>采集点维护</h1>
      <div class="deviceMng_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>

    <!-- 查询条件 -->
    <div class="deviceMng_query">
      <div class="query_list clearfix fl">
        <span class="fl">归属机构：</span>
        <el-cascader
          class="fl"
          :clearable="true"
          v-model="value"
          :checkStrictly="true"
          :options="options"
          placeholder="系统管理机构"
          filterable
          :props="{ expandTrigger: 'hover', checkStrictly: true }"
          @change="handleChange"
        ></el-cascader>
      </div>

      <div class="query_list clearfix fl">
        <span class="fl">设备名称：</span>
        <div class="fl">
          <el-input placeholder="请输入内容" v-model="deviceName" clearable>
          </el-input>
        </div>
      </div>

      <div class="query_list clearfix fl">
        <span class="fl">内部码：</span>
        <div class="fl">
          <el-input placeholder="请输入内容" v-model="innerCode" clearable>
          </el-input>
        </div>
      </div>

      <div class="query_list clearfix fl">
        <span class="fl">启用状态：</span>
        <el-select clearable v-model="enable" placeholder="请选择">
          <el-option
            v-for="item in enableList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div class="query_list clearfix fl">
        <span class="fl">在线状态：</span>
        <el-select clearable v-model="online" placeholder="请选择">
          <el-option
            v-for="item in onlineList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <el-button type="primary" @click="queryClick()" icon="el-icon-search">
        查询
      </el-button>
    </div>

    <div class="deviceMng_text">
      <p>
        地理位置填写格式：城市＋区县＋城镇＋乡村＋街道＋门牌号码，如“北京市朝阳区阜通东大街6号”
      </p>
      <p>
        地理位置按正确格式填写后，系统会自动拾取坐标信息。数据修改保存后，请退出系统并重新登录！
      </p>
    </div>

    <!-- 数据展示 -->
    <div class="deviceMng_content">
      <div class="deviceMng_title">
        <el-row>
          <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
            <div class="">状态</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">归属机构</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">采集点名称</div>
          </el-col>
          <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <div class="">地理位置</div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <div class="">经度</div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <div class="">纬度</div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="">报送编号</div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <div class="">采数周期</div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <div class="">使用状态</div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <div class="">操作</div>
          </el-col>
        </el-row>
      </div>

      <div v-show="deviceMngList.length > 0">
        <div
          class="deviceMng_list"
          v-for="(item, index) in deviceMngList"
          :key="index"
          :title="item.innerCode"
        >
          <el-row>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
              <div class="deviceMng_tab">
                <i
                  class="el-icon-s-data"
                  :style="{
                    fontSize: '22px',
                    color: item.online == 1 ? '#70FC79' : '#999999',
                  }"
                  :title="item.online == 1 ? '在线' : '离线'"
                ></i>
              </div>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
              <div class="deviceMng_tab">
                <el-button
                  size="mini"
                  plain
                  type="primary"
                  @click="chooseClick(index)"
                  icon="el-icon-folder-opened"
                  >{{ item.deptName }}</el-button
                >
              </div>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
              <div class="deviceMng_tab">
                <input type="text" v-model="item.deviceName" />
              </div>
            </el-col>
            <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <div class="deviceMng_tab">
                <input type="text" v-model="item.address" />
              </div>
            </el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
              <div class="deviceMng_tab">
                <input type="text" v-model="item.longitude" />
              </div>
            </el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
              <div class="deviceMng_tab">
                <input type="text" v-model="item.latitude" />
              </div>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
              <div class="deviceMng_tab">
                <input type="text" v-model="item.leader" />
              </div>
            </el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
              <div class="deviceMng_tab">
                <el-select
                  v-model="item.rhythm"
                  size="mini"
                  :disabled="item.useType == 5 ? false : true"
                  :title="
                    item.useType == 5 ? '协议卡设备可修改' : 'HJ212设备无效参数'
                  "
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in cyclesList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
              <div class="deviceMng_tab">
                <el-select
                  v-model="item.enable"
                  size="mini"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in stateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
              <div class="deviceMng_tab">
                <i
                  class="el-icon-folder-opened"
                  :style="{ color: '#409EFF' }"
                  @click="saveClick(index)"
                  title="保存"
                ></i>
                <i
                  class="el-icon-delete"
                  :style="{ color: '#FF0000' }"
                  @click="deleteClick(index)"
                  title="删除"
                ></i>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="deviceMng_btn">
          <span>共{{ total }}条数据</span>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="total"
            background
          >
          </el-pagination>
        </div>
      </div>

      <div v-show="deviceMngList.length == 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

    <!-- 选择机构 -->
    <el-drawer
      title="选择机构"
      size="40%"
      :visible.sync="drawer"
      :modal-append-to-body="false"
    >
      <div class="drawer_box">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText">
        </el-input>

        <el-tree
          class="filter-tree"
          :data="options"
          node-key="value"
          :default-checked-keys="keys"
          :default-expand-all="true"
          :expand-on-click-node="false"
          :check-strictly="true"
          :props="defaultProps"
          show-checkbox
          :filter-node-method="filterNode"
          @check="handleCheckChange"
          ref="tree"
        >
        </el-tree>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
export default {
  data() {
    return {
      // 机构ID
      keys: [],
      // 选择数据下标
      index: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 显示/隐藏
      drawer: false,
      // 搜索字符
      filterText: "",

      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",

      // 机构树
      options: [],
      // 当前选择机构
      value: [],
      // 当前机构ID
      deptId: "",

      // 采数周期LIST
      cyclesList: [
        {
          value: "60000",
          label: "1分钟",
        },
        {
          value: "180000",
          label: "3分钟",
        },
        {
          value: "300000",
          label: "5分钟",
        },
        {
          value: "480000",
          label: "8分钟",
        },
        {
          value: "600000",
          label: "10分钟",
        },
        {
          value: "900000",
          label: "15分钟",
        },
        {
          value: "1800000",
          label: "30分钟",
        },
        {
          value: "2700000",
          label: "45分钟",
        },
        {
          value: "3600000",
          label: "60分钟",
        },
      ],
      // 设备名称
      deviceName: "",
      // 内部码
      innerCode: "",
      // 当前页数
      page: 1,
      // 总数据数
      total: 0,

      // 启用状态
      enable: "",
      // 启用状态LIST
      enableList: [
        {
          value: "0",
          label: "停用",
        },
        {
          value: "1",
          label: "启用",
        },
      ],
      // 使用状态List
      stateList: [
        {
          value: "0",
          label: "停用",
        },
        {
          value: "1",
          label: "启用",
        },
      ],
      // 在线状态
      online: "",
      // 在线状态LIST
      onlineList: [
        {
          value: "0",
          label: "离线",
        },
        {
          value: "1",
          label: "在线",
        },
      ],

      //   数据列表
      deviceMngList: [],

      //   查询LIST
      queryList: {
        enable: "",
        online: "",
        deviceName: "",
        innerCode: "",
        deptId: "",
        page: 1,
      },
    };
  },
  created() {
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);

    let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }

    // 获取机构树
    this.options = JSON.parse(localStorage.getItem("structure"));

    // console.log(this.options)

    // 调用采集点维护
    this.DeviceMng(this.queryList);
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    //   查询
    queryClick() {
      this.page = 1;

      let val = JSON.parse(JSON.stringify(this.value));
      if (val.length >= 1) {
        this.queryList.deptId = val[val.length - 1];
      } else {
        this.queryList.deptId = "";
      }

      this.queryList.deviceName = this.deviceName;
      this.queryList.innerCode = this.innerCode;
      this.queryList.enable = this.enable;
      this.queryList.online = this.online;
      this.queryList.page = 1;

      //   调用采集点维护
      this.DeviceMng(this.queryList);
    },
    // 采集点维护 LIST
    DeviceMng(queryList) {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DeviceMng", //交易码
          option: "LIST", //交易选项
          enable: queryList.enable, //启用状态，0停用，1启用，不填表示不区分。
          online: queryList.online, //在线状态，0离线，1在线。
          deviceName: queryList.deviceName, //采集点名称
          innerCode: queryList.innerCode, //内部码
          leader: "", //报送编号
          deptId: queryList.deptId, //归属机构ID，不填表示查询本级以及下属子机构所有设备。
          page: queryList.page, //当前页码
          loginToken,
        },
      })
        .then((res) => {
          // console.log(res);
          if (res.data._STATUS == 0) {
            // 获取原始机构树
            let institutions = JSON.parse(localStorage.getItem("institutions"));
            let arr = [];
            for (let i = 0; i < res.data.list.length; i++) {
              (function (i) {
                let lists = {};
                for (let j = 0; j < institutions.length; j++) {
                  lists.online = res.data.list[i].online;
                  lists.deptId = res.data.list[i].deptId;
                  lists.deviceId = res.data.list[i].deviceId;
                  lists.deviceName = res.data.list[i].deviceName;
                  lists.address = res.data.list[i].address;
                  lists.longitude = res.data.list[i].longitude;
                  lists.latitude = res.data.list[i].latitude;
                  lists.leader = res.data.list[i].leader;
                  lists.rhythm = res.data.list[i].rhythm;
                  lists.enable = res.data.list[i].enable;
                  lists.innerCode = res.data.list[i].innerCode;
                  lists.mobile = res.data.list[i].mobile;
                  lists.limitDate = res.data.list[i].limitDate;
                  lists.useType = res.data.list[i].useType;
                  lists.ip = res.data.list[i].ip;
                  lists.port = res.data.list[i].port;
                  lists.addr485 = res.data.list[i].addr485;

                  if (res.data.list[i].deptId == "100000000") {
                    lists.deptName = "系统管理机构";
                  }
                  if (institutions[j].deptId == res.data.list[i].deptId) {
                    lists.deptName = institutions[j].deptName;
                    break;
                  }
                }
                arr.push(lists);
              })(i);
            }
            this.deviceMngList = arr;
            this.total = res.data.rowsCount;
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 选择跳转分页
    handleCurrentChange(val) {
      this.queryList.page = val;
      // 调用采集点监控
      this.DeviceMng(this.queryList);
    },
    // 现在所属机构
    handleChange(value) {
      if (value.length == 0) {
        this.patchLists = [];
      }
      this.deviceId = "";
      let val = JSON.parse(JSON.stringify(value));
      if (val.length >= 1) {
        this.deptId = val[val.length - 1];
      } else {
        this.deptId = "";
      }
    },
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },

    // 保存
    saveClick(index) {
      let loginToken = localStorage.getItem("loginToken");
      let arr = {
        txcode: "DeviceMng", //交易码
        option: "SAVE", //交易选项
        deviceId: this.deviceMngList[index].deviceId, //设备ID（索引号，不能修改）
        loginToken,
      };

      let list = [
        "deptId",
        "deviceName",
        "address",
        "longitude",
        "latitude",
        "latitude",
        "leader",
        "enable",
        "ip",
        "port",
        "addr485",
        "mobile",
        "rhythm",
        "limitDate",
      ];
      for (let i = 0; i < list.length; i++) {
        arr[list[i] + "_" + this.deviceMngList[index].deviceId] =
          this.deviceMngList[index][list[i]];
      }
      this.$axios({
        method: "post",
        url: this.api,
        data: arr,
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 删除
    deleteClick(index) {
      this.$confirm("此操作将永久删除该设备信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let loginToken = localStorage.getItem("loginToken");
        let arr = {
          txcode: "DeviceMng", //交易码
          option: "SAVE", //交易选项
          deviceId: this.deviceMngList[index].deviceId, //设备ID（索引号，不能修改）
          loginToken,
        };

        arr["deviceName_" + this.deviceMngList[index].deviceId] =
          this.deviceMngList[index].deviceName;

        this.$axios({
          method: "post",
          url: this.api,
          data: arr,
        })
          .then((res) => {
            if (res.data._STATUS == "0") {
              this.$message({
                message: "删除成功",
                type: "success",
              });

              // 获取采集点维护 LIST
              this.DeviceMng(_this.queryList);
            } else {
              // 登录超时，调用全局方法
              this.loginTimeout();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    // 选择机构
    chooseClick(index) {
      this.index = index;
      // 获取结构树
      this.options = JSON.parse(localStorage.getItem("structure"));
      this.keys[0] = this.deviceMngList[index].deptId;
      this.drawer = true;
    },
    // 选择修改的机构
    handleCheckChange(data) {
      this.keys = [];
      this.drawer = false;
      this.keys.push(data.value);

      this.deviceMngList[this.index].deptId = data.value;
      this.deviceMngList[this.index].deptName = data.label;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="less" scoped>
// 表头
.deviceMng {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .deviceMng_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .deviceMng_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

// 查询条件
.deviceMng_query {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  .query_list {
    height: 46px;
    line-height: 40px;
    margin-right: 20px;
  }
}

.deviceMng_text {
  width: 100%;
  padding: 0px 20px;
  box-sizing: border-box;
  p {
    line-height: 26px;
    color: red;
  }
}

// 数据展示
.deviceMng_content {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;

  .deviceMng_title {
    width: 100%;
    text-align: center;
    color: #fff;
    height: 40px;
    line-height: 40px;
    background-color: #545c64;
  }

  .deviceMng_list {
    width: 100%;
    text-align: center;
    &:nth-child(2n-1) {
      background-color: #f0faff;
    }
    &:hover {
      cursor: pointer;
      background-color: rgb(253, 246, 238);
    }
    .deviceMng_tab {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333;
      min-height: 40px;
      i {
        font-size: 18px;
        margin: 0 5px;
        &:hover {
          cursor: pointer;
        }
      }
      input {
        width: 90%;
        min-height: 24px;
        text-align: center;
        border: 1px solid #999;
      }
      select {
        width: 80%;
        min-height: 24px;
        border: 1px solid #999;
      }

      .el-select {
        width: 80%;
      }
    }
  }

  .deviceMng_btn {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      margin: 0 20px;
      color: #666666;
    }
  }
}

.drawer_box {
  width: 100%;
  height: calc(100% - 50px);
  overflow-y: auto;
  padding: 0 20px 50px;
  box-sizing: border-box;
}
</style>